import React, { useEffect, createContext, useMemo, useCallback } from 'react'
import { useGetTopicDetails } from '@/hooks/api/dashboard'
import { useBrowserQuery, useAuth } from '@/hooks/common'
import { useLocation, useNavigate } from 'react-router-dom'
import useAppStore from '@/store/useAppStore'
import { HOME_PATH, TopicType, TopicTypes } from '@/utils/constants'
import PatternTopicPreview from './pattern'
import AlbumTopicPreview from './album'
import TopicDetailsView from './common/TopicDetailsView'
import { shallow } from 'zustand/shallow'

import { Topic } from '@/types'
import { TopicDetailsContext } from '@/context/TopicDetails'
import LoadingAnimatedView from '@/components/LoadingAnimatedView'
import { isBabylonType } from '@/utils/helper'
import { Box } from '@mui/material'
export const TopicPreviewBase = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const query = useBrowserQuery()
  const [sideTabPath, topicList] = useAppStore(
    (state) => [state.app.sideTabPath, state.home.topicList],
    shallow,
  )
  const { markAsReadForTopic } = useAppStore()

  const getTopicDetails = useGetTopicDetails()
  const topicID = query.get('topicID') || ''
  const topicTypeQuery = query.get('topicType') || ''
  const topicType = topicTypeQuery.length > 0 ? TopicTypes[topicTypeQuery].type : undefined

  useEffect(() => {
    // Allow public preview - don't redirect to login for guests
    // Only check if topic params are valid

    if (topicID.length == 0 || topicTypeQuery.length == 0 || topicType == undefined) {
      // If logged in, go home; if guest, go to landing page
      navigate(user?.userID ? '/' : '/')
    }
  }, [topicID, topicTypeQuery, topicType, user?.userID])

  useEffect(() => {
    if (topicID) {
      getTopicDetails.mutateAsync({ topicID })
      markAsReadForTopic(topicID)
    }
  }, [topicID])

  const topic = useMemo(() => {
    return topicList[topicID]
  }, [topicID, topicList])

  const onClickBack = () => {
    const canGoBack =
      typeof window !== 'undefined' &&
      typeof window.history.state?.idx === 'number' &&
      window.history.state.idx > 0

    if (canGoBack) {
      navigate(-1)
    } else {
      navigate('/', { replace: true })
    }
  }

  const canLoadNextPage = (): boolean => {
    if (topic.pagination) {
      return topic.pagination.currentPage < topic.pagination.totalPages
    }
    return false
  }

  const loadNextPage = () => {
    let currentPage = topic.pagination?.currentPage || 1
    return getTopicDetails.mutateAsync({ topicID, pageNo: currentPage + 1 })
  }
  return (
    <>
      {topic ? (
        <TopicDetailsContext.Provider value={{ topic, onClickBack, loadNextPage, canLoadNextPage }}>
          {isBabylonType(Number(topicType)) ? <PatternTopicPreview /> : <TopicDetailsView />}
        </TopicDetailsContext.Provider>
      ) : (
        <Box sx={{ background: '#FFF', flex: 1, paddingTop: 8 }}>
          <LoadingAnimatedView showGif={false} />
        </Box>
      )}
    </>
  )
}
